import { Source, SourceOptions } from "./Source";

export class CitySource extends Source {
}

export interface CitySourceOptions extends SourceOptions {
  iconUrl: string
}